import dayjs from 'dayjs';
import moment from 'moment';
import settings from '/@/core/settings';
import { assignYearsToDateRange, parseYearlessDate } from '/@/utils/date';

// Global
export const isDateInRanges = (date, ranges) => {
    if (!ranges) return true;
    return Boolean(
        ranges.find(
            ([min, max]) =>
                (min ? moment(min).subtract(1, 'days').isBefore(date, 'day') : true) &&
                (max ? moment(max).add(1, 'days').isAfter(date, 'day') : true)
        )
    );
};

export const getClosestDate = (referenceParam, ranges) => {
    const reference = moment(referenceParam);
    if (!ranges || isDateInRanges(reference, ranges)) return reference;
    return ranges.reduce((result, [start]) => {
        const startDate = moment(start);
        return Math.abs(result.diff(reference)) <= Math.abs(startDate.diff(reference)) ? result : startDate;
    }, moment(ranges?.[0]?.[0]));
};

export const getByNearestDate = (items, target, key) => {
    if (!items.length) return;
    return items.reduce((acc, current) => {
        const accDate = moment(acc[key]);
        const currentDate = moment(current[key]);
        return Math.abs(currentDate.diff(target)) <= Math.abs(accDate.diff(target)) ? current : acc;
    });
};

export const getDefaultPlantingDates = (zones, zoneType) => {
    if (!zoneType) return;
    return zones
        .filter((zone) => zone.type === settings.enums.zoneTypes?.[zoneType]?.value)
        .map((zone) => {
            const assignedDates = assignYearsToDateRange(zone.minDate, zone.maxDate, zone.defaultPlantingDate);
            return assignedDates?.defaultPlantingDate;
        })
        .filter(Boolean)
        .sort((a, b) => dayjs(a).diff(dayjs(b)));
};

export const getZoneByDate = (zones, zoneType, date) => {
    if (!zoneType) return {};

    // Use the yearless version since dates are now in MM/DD format
    return getZoneByDateYearless(zones, zoneType, date);
};

export const getZoneByDateYearless = (zones, zoneType, date) => {
    if (!date) return;
    const filteredZones = zones.filter(
        (zone) => zone.type === settings.enums.zoneTypes?.[zoneType]?.value && zone.minDate && zone.maxDate
    );

    return filteredZones.find((zone) => {
        return parseYearlessDate.isInRange(date, zone.minDate, zone.maxDate);
    });
};
